// extracted by mini-css-extract-plugin
module.exports = {"content":"content-3buRs","closeIcon":"closeIcon-2SI2f","sliderRoot":"sliderRoot-3WS39","heading":"heading-SasOV","text":"text-2JQSV","icons":"icons-1P96G","icon":"icon-3mXEv"};